import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import CardMedia from "@mui/material/CardMedia";
import classnames from "classnames";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function CardMedia_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else CardMedia_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const CardMedia_CardMedia = (t0)=>{
    const $ = c(23);
    let alt;
    let children;
    let height;
    let image;
    let rest;
    let src;
    let sx;
    let t1;
    let width;
    if ($[0] !== t0) {
        ({ component: t1, image, alt, children, sx, src, width, height } = t0), rest = _object_without_properties(t0, [
            "component",
            "image",
            "alt",
            "children",
            "sx",
            "src",
            "width",
            "height"
        ]);
        $[0] = t0;
        $[1] = alt;
        $[2] = children;
        $[3] = height;
        $[4] = image;
        $[5] = rest;
        $[6] = src;
        $[7] = sx;
        $[8] = t1;
        $[9] = width;
    } else {
        alt = $[1];
        children = $[2];
        height = $[3];
        image = $[4];
        rest = $[5];
        src = $[6];
        sx = $[7];
        t1 = $[8];
        width = $[9];
    }
    const component = void 0 === t1 ? "div" : t1;
    const mediaSrc = image || src;
    let t2;
    if ($[10] !== component || $[11] !== height || $[12] !== sx || $[13] !== width) {
        t2 = "img" === component ? _object_spread({
            width: width || "100%",
            height: height || "100%",
            objectFit: "cover"
        }, sx || {}) : _object_spread({
            width,
            height
        }, sx || {});
        $[10] = component;
        $[11] = height;
        $[12] = sx;
        $[13] = width;
        $[14] = t2;
    } else t2 = $[14];
    const imgStyles = t2;
    let t3;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = classnames("aqa_card_media");
        $[15] = t3;
    } else t3 = $[15];
    let t4;
    if ($[16] !== alt || $[17] !== children || $[18] !== component || $[19] !== imgStyles || $[20] !== mediaSrc || $[21] !== rest) {
        t4 = /*#__PURE__*/ jsx(CardMedia, _object_spread_props(_object_spread({
            component: component,
            image: mediaSrc,
            alt: alt,
            className: t3,
            sx: imgStyles
        }, rest), {
            children: children
        }));
        $[16] = alt;
        $[17] = children;
        $[18] = component;
        $[19] = imgStyles;
        $[20] = mediaSrc;
        $[21] = rest;
        $[22] = t4;
    } else t4 = $[22];
    return t4;
};
export { CardMedia_CardMedia as CardMedia };
